
<div class="actions">
  <ProductPrice :price="price" :instead-of="insteadOf" :from="from"/>
  <v-btn color="primary" @click.stop="$emit('configure')">
    <v-icon v-if="icon" left>{{ icon }}</v-icon>
    {{ label }}
  </v-btn>
</div>
